import React from 'react'
import { Breadcrumbs } from '@/components/ui/breadcrumb'
import { links } from 'utils/featureToggles'

import { getTicketBrokerageAndTranslationsFields } from '../../components/Filter/TicketFields/getTicketBrokerageAndTranslationsFields'
import Tickets from './Tickets/Tickets'
import { ticketsBrokerageColumn } from './ticketsBrokerageColumn'
import { TicketsViewType } from './TicketsViewType'

const TicketsBrokerage = (): JSX.Element => (
  <React.Fragment>
    <Breadcrumbs crumbs={[{ title: 'Brokerage Tickets', link: links.ticketsBrokerage.url }]} />
    <Tickets
      viewType={TicketsViewType.Brokerage}
      columns={ticketsBrokerageColumn}
      filterFields={getTicketBrokerageAndTranslationsFields}
    />
  </React.Fragment>
)

export default TicketsBrokerage
